{
  "en": {
    "models": {
      "name": "Ships",
      "model": {
        "metrics": {
          "base": "Base",
          "crew": "Crew",
          "info": "Info",
          "levels": "Levels",
          "speed": "Speed"
        },
        "focus": "Focus",
        "classification": "Classification",
        "size": "Size",
        "beam": "Beam",
        "cargo": "Cargo",
        "netCargo": "Cargo with Rover/Snub",
        "crew": "Crew",
        "speed": "Speed",
        "minCrew": "min. Crew",
        "maxCrew": "max. Crew",
        "scmSpeed": "SCM Speed",
        "maxSpeed": "Max Speed",
        "scm": "SCM",
        "max": "Max",
        "groundMaxSpeed": "Max Speed",
        "groundReverseSpeed": "Reverse Speed",
        "pitch": "Pitch",
        "yaw": "Yaw",
        "roll": "Roll",
        "price": "Price",
        "groundAcceleration": "Acceleration",
        "groundDecceleration": "Decceleration",
        "scmSpeedAcceleration": "Zero to SCM",
        "scmSpeedDecceleration": "SCM to Zero",
        "maxSpeedAcceleration": "Zero to Max",
        "maxSpeedDecceleration": "Max to Zero",
        "compare": {
          "groundMaxSpeed": "Max Ground Speed",
          "groundReverseSpeed": "Reverse Ground Speed",
          "groundAcceleration": "Ground Acceleration",
          "groundDecceleration": "Ground Decceleration"
        },
        "quantumFuelTankSize": "Quantum Fuel",
        "hydrogenFuelTankSize": "Fuel",
        "pledgePrice": "Pledge Price",
        "height": "Height",
        "length": "Length",
        "mass": "Mass",
        "manufacturer": "Manufacturer",
        "hardpoints": "Hardpoints",
        "weapons": "Weapons",
        "equipment": "Equipment",
        "variants": "Variants",
        "maxUpgrades": "Upgrades",
        "productionStatus": "Production Status",
        "propulsion": "Propulsion",
        "ordnance": "Ordnance",
        "modular": "Modular",
        "soldAt": "Sold at?",
        "rentalAt": "Rental at?",
        "lastUpdatedAt": "Last updated at?",
        "loaners": "Loaners",
        "paints": "Paints",
        "modules": "Modules",
        "modulePackages": "Module Packages",
        "upgrades": "Upgrade-Kits",
        "brochure": "Brochure",
        "onSale": "On Sale",
        "salesPage": "Sales Page",
        "addons": "Modules & Upgrade-Kits",
        "productionStatuses": {
          "notAvailable": "N/A",
          "in-production": "In Production",
          "in-concept": "In Concept",
          "ready": "Hangar Ready",
          "flight-ready": "Flight Ready",
          "announced": "Announced"
        }
      }
    }
  }
}
